<template>
    <div>
        <htmlHeader :top_index="0" :menuCode="false" :crumbsShow="true" />

        <div style="width: 1200px; margin: auto; padding-bottom: 10%; overflow: hidden">
            <userLeft :active="8" />
            <div class="box5">
                <div style="overflow: hidden">
                    <div class="box6" style="float: left">增加发票信息</div>
                </div>
                <div class="box7"></div>
                <div style="overflow: hidden; margin-top: 2%">
                    <div class="item_title"><span style="color: red">*</span> 发票类型：</div>
                    <div class="item_title" style="text-align: left; margin-left: 20px">
                        增值税专用发票
                    </div>
                </div>
                <div style="overflow: hidden; margin-top: 2%">
                    <div class="item_title"><span style="color: red">*</span> 发票抬头：</div>
                    <div style="margin-top:15px;margin-left:205px">{{ qiyexinxi }}</div>
                    <!-- <a-input
            v-model="obj.title"
            placeholder="请输入企业全称"
            style="
              float: left;
              width: 300px;
              margin-left: 20px;
              margin-top: 10px;
            "
          /> -->
                </div>
                <div style="overflow: hidden; margin-top: 2%">
                    <div class="item_title"><span style="color: red">*</span> 统一社会信用代码：</div>
                    <a-input
                        v-model="obj.unifiedSocialCreditCode"
                        placeholder="请输入统一社会信用代码"
                        style="
              float: left;
              width: 300px;
              margin-left: 20px;
              margin-top: 10px;
            "
                    />
                </div>

                <div style="overflow: hidden; margin-top: 2%">
                    <div class="item_title"><span style="color: red">*</span> 注册地址</div>
                    <a-input
                        v-model="obj.registerAddress"
                        placeholder="请输入注册地址"
                        style="
              float: left;
              width: 300px;
              margin-left: 20px;
              margin-top: 10px;
            "
                    />
                </div>

                <div style="overflow: hidden; margin-top: 2%">
                    <div class="item_title"><span style="color: red">*</span> 注册电话</div>
                    <a-input
                        v-model="obj.registerTel"
                        placeholder="请输入注册电话号码"
                        style="
              float: left;
              width: 300px;
              margin-left: 20px;
              margin-top: 10px;
            "
                    />
                </div>

                <div style="overflow: hidden; margin-top: 2%">
                    <div class="item_title"><span style="color: red">*</span> 开户银行</div>
                    <a-input
                        v-model="obj.bankName"
                        placeholder="请输入开户银行"
                        style="
              float: left;
              width: 300px;
              margin-left: 20px;
              margin-top: 10px;
            "
                    />
                </div>

                <div style="overflow: hidden; margin-top: 2%">
                    <div class="item_title"><span style="color: red">*</span> 银行账号</div>
                    <a-input
                        v-model="obj.bankAccount"
                        placeholder="请输入银行账号"
                        style="
              float: left;
              width: 300px;
              margin-left: 20px;
              margin-top: 10px;
            "
                    />
                </div>

                <!-- <div style="overflow: hidden; margin-top: 2%">
                    <div class="item_title"><span style="color: red"></span> 证书扫描x件</div>
                    <div style="overflow: hidden; float: left">
                        <div style="float: left; margin-left: 20px">
                            <a-upload name="file" list-type="picture-card" class="avatar-uploader" :show-upload-list="false" action="/api/file/upload" @change="add_uploader1">
                                <img style="width: 90px; height: 90px;" v-if="scanList1" :src="'/api/file/preview/' + scanList1" alt="avatar" />
                                <div v-else>
                                    <a-icon :type="loading ? 'loading' : 'plus'" />
                                    <div class="ant-upload-text">上传扫描件</div>
                                </div>
                            </a-upload>
                        </div>
                        <div style="float: left; margin-left: 20px">
                            <a-upload name="file" list-type="picture-card" class="avatar-uploader" :show-upload-list="false" action="/api/file/upload" @change="add_uploader2">
                                <img style="width: 90px; height: 90px;" v-if="scanList2" :src="'/api/file/preview/' + scanList2" alt="avatar" />
                                <div v-else>
                                    <a-icon :type="loading ? 'loading' : 'plus'" />
                                    <div class="ant-upload-text">上传扫描件</div>
                                </div>
                            </a-upload>
                        </div>
                        <div style="float: left; margin-left: 20px">
                            <a-upload name="file" list-type="picture-card" class="avatar-uploader" :show-upload-list="false" action="/api/file/upload" @change="add_uploader3">
                                <img style="width: 90px; height: 90px;" v-if="scanList3" :src="'/api/file/preview/' + scanList3" alt="avatar" />
                                <div v-else>
                                    <a-icon :type="loading ? 'loading' : 'plus'" />
                                    <div class="ant-upload-text">上传扫描件</div>
                                </div>
                            </a-upload>
                        </div>
                    </div>
                </div> -->

                <div style="overflow: hidden; margin-top: 2%">
                    <div class="item_title"><span style="color: red"></span></div>
                    <div class="submit_but" @click="add_user_invoice" style="margin-left: 20px; float: left">
                        提交
                    </div>
                </div>
            </div>
        </div>
        <foot />
    </div>
</template>

<script>
import axios from 'axios';
import userLeft from '../public/user_left';
import htmlHeader from '../public/head';
import foot from '../public/foot';
export default {
    name: 'AddZhuanpiao',
    components: {
        userLeft,
        htmlHeader,
        foot
    },
    data() {
        return {
            qiyexinxi: '',
            uuid: null, //编辑 ID
            scanList1: '',
            scanList2: '',
            scanList3: '',
            obj: {
                title: '',
                unifiedSocialCreditCode: '',
                type: 'DEDICATED',
                bankAccount: '',
                bankName: '',
                registerAddress: '',
                registerTel: '',
                scanList: [],
                scanList1: '',
                scanList2: '',
                scanList3: ''
            }
        };
    },
    methods: {
        add_uploader1(e) {
            if (e.file.status === 'done') {
                this.scanList1 = e.file.response.data.uuid;
            }
        },
        add_uploader2(e) {
            if (e.file.status === 'done') {
                this.scanList2 = e.file.response.data.uuid;
            }
        },
        add_uploader3(e) {
            if (e.file.status === 'done') {
                this.scanList3 = e.file.response.data.uuid;
            }
        },
        // 提交
        add_user_invoice() {
            console.log(this.obj.title == '', this.obj.unifiedSocialCreditCode == '', this.obj.bankAccount == '', this.obj.bankName == '', this.obj.registerAddress == '', this.obj.registerTel == '');
            if (this.obj.unifiedSocialCreditCode == '' || this.obj.bankAccount == '' || this.obj.bankName == '' || this.obj.registerAddress == '' || this.obj.registerTel == '') {
                this.$message.error('请完善信息');
                return false;
            }

            this.obj.scanList = [this.scanList1, this.scanList2, this.scanList3];

            if (this.uuid) {
                this.obj.uuid = this.uuid;
            }
            this.api.add_user_invoice(this.obj).then(res => {
                if (res.ok) {
                    this.$router.push('/control_over_invoices');
                } else {
                    this.$message.error(res.message);
                }
            });
        }
    },
    created() {
        // 是否编辑
        this.api.get_companyFullName().then(res => {
            this.qiyexinxi = res.data;
            this.obj.title = res.data;
            console.log(res, '企业信息');
        });
        if (this.$route.query.uuid) {
            this.api.get_user_invoice('DEDICATED').then(res => {
                if (res.ok) {
                    this.obj = res.data;
                    this.scanList1 = res.data.scanList[0] ? res.data.scanList[0] : '';
                    this.scanList2 = res.data.scanList[1] ? res.data.scanList[1] : '';
                    this.scanList3 = res.data.scanList[2] ? res.data.scanList[2] : '';
                    this.uuid = res.data.uuid;
                } else {
                    this.$message.error(res.message);
                }
            });
        }
    }
};
</script>

<style scoped>
.submit_but {
    width: 100px;
    height: 40px;
    border: 1px solid #2b9a34;
    margin: 4% auto;
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2b9a34;
    cursor: pointer;
}
.xuxian {
    width: 100%;
    height: 1px;
    border-bottom: 1px dashed #e8e6e6;
    margin-top: 2%;
}
.item_title {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 42px;
    text-align: right;
    float: left;
    margin-top: 5px;
    width: 20%;
}
.box14 {
    width: 120px;
    height: 32px;
    border: 1px solid #2c9a34;
    float: right;
    text-align: center;
    line-height: 32px;

    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2c9a34;
}
.box13 {
    width: 16.6666%;
    height: 100%;
    float: left;

    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 40px;
}
.box12 {
    width: 100%;
    height: 40px;
    background: #f4f4f4;
    margin-top: 4%;
}
.box11 {
    width: 100px;
    height: 32px;
    border: 1px solid #2b9a34;
    margin: 8% auto;
    text-align: center;
    line-height: 32px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2b9a34;
}

.box10 {
    font-size: 40px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ff9629;
    /* line-height: 16px; */
    margin: 4% auto;
}

.box9 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    margin: auto;
}

.box8 {
    width: 100%;
    height: 105px;
    background: EEF7EF;
    /* opacity: 0.08; */
    padding-top: 4%;
}

.box7 {
    width: 100%;
    height: 1px;
    border-top: 1px solid #e8e6e6;
    margin-top: 2%;
}

.box6 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    /* margin-top: 2%; */
    text-align: left;
}

.box5 {
    width: 80%;
    /* min-height: 1023px; */
    border: 1px solid #ede9e9;
    float: right;
    margin-top: 2%;
    padding: 2%;
    min-height: 1023px;
}

.box3 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: Regular;
    color: #666666;
    margin-top: 6%;
}

.box4 {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
}

.box1 {
    width: 220px;
    min-height: 1023px;
    border: 1px solid #ede9e9;
    float: left;
    margin-top: 2%;
}

.box2 {
    width: 100%;
    height: 45px;
    background: #f2f2f2;
}
</style>



// WEBPACK FOOTER //
// src/components/add_zhuanpiao.vue